// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateEvent/DatesModal/DatesModal.css
// module id = 1664
// module chunks = 0